import { Link, Outlet } from "react-router";

import { LogoWithTitle } from "@/site/ui/logo-with-title";
import { ThemeControl } from "@/site/ui/theme-control";
import { Button } from "@/ui/button";

// Frame the public site with restrained navigation and a quiet utility footer.
export default function MarketingLayout() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="mx-auto flex min-h-dvh w-[calc(100%-2rem)] max-w-6xl flex-col sm:w-[calc(100%-3rem)]">
      <header className="flex h-18 items-center justify-between">
        <LogoWithTitle linkTo="/" />

        <nav
          aria-label="Public navigation"
          className="hidden items-center gap-7 text-sm md:flex"
        >
          <Link
            className="underline-decoration hover:underline"
            to="/#how-it-works"
          >
            How it works
          </Link>
          <Link
            className="underline-decoration hover:underline"
            to="/#for-families"
          >
            For families
          </Link>
          <Link className="underline-decoration hover:underline" to="/pricing">
            Pricing
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          <ThemeControl className="hidden lg:flex" />
          <Button
            asChild
            className="hidden h-11 sm:inline-flex"
            variant="ghost"
          >
            <Link to="/login">Sign in</Link>
          </Button>
          <Button asChild className="h-11">
            <Link to="/login">Create a ledger</Link>
          </Button>
        </div>
      </header>

      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>

      <footer className="text-muted-foreground flex flex-col gap-5 border-t py-8 text-sm sm:flex-row sm:items-center sm:justify-between sm:py-10">
        <div>
          <p>
            © {currentYear} {publicEnv.siteTitle}
          </p>
          <p className="mt-1">Make sense of every cent.</p>
        </div>

        <div className="flex flex-wrap items-center gap-x-5 gap-y-3">
          <Link className="underline-decoration hover:underline" to="/pricing">
            Pricing
          </Link>
          <Link className="underline-decoration hover:underline" to="/terms">
            Terms
          </Link>
          <Link className="underline-decoration hover:underline" to="/privacy">
            Privacy
          </Link>
          <ThemeControl />
        </div>
      </footer>
    </div>
  );
}
